import React from "react";
import { useTranslation } from "react-i18next";
import { IError } from "../models/Types";

export default function ErrorView(props: IError) {
  const { t } = useTranslation();

  return (
    <div className={"errorContainer"}>
      {props.showIcon && <img src={`static/error.svg`} width={100}></img>}
      <p>{props.message}</p>

      {props.showRetry && (
        <button
          type="button"
          className={`btn rounded-full btn-small btn-solid-purple btn-full-width`}
          onClick={() => props.retryCallback()}
        >
          <div>{t("Retry.text")}</div>
        </button>
      )}

      <p className={"problem-area"}>
        {t("HaveAProblem.text")}{" "}
        <a
          href="https://proton.me/support/contact?topic=account+security&message=[ProtonCAPTCHA Issue] "
          target="_new"
        >
          {t("ReportProblem.text")}
        </a>
        .
      </p>
    </div>
  );
}
